import { components, paths } from "@api/api";
import useFetch from "@hooks/useFetch";
import { getApiLink } from "@core/utils/url";
import { useEffect, useState } from "react";

const path: keyof paths = '/api/Benchmark/Search';
export type CustomBenchmarkSearchData = components["schemas"]["CustomBenchmarkSearchResponse"];

export function useCustomBenchmarkSearch(query: string) {
    const [data, setData] = useState<CustomBenchmarkSearchData | null>(null);
    const request = useFetch<CustomBenchmarkSearchData>({
        url: getApiLink(path, { query }) as keyof paths,
        lazy: query === '',
    });

    useEffect(() => {
        if (request.isLoading) setData(null);
    }, [request.isLoading]);

    useEffect(() => {
        setData(request.data);
    }, [request.data]);

    return {
        ...request,
        data,
    };
}